// extracted by mini-css-extract-plugin
module.exports = {"cancelBtn":"OrderActions_cancelBtn__V4Qqn","actionBtn":"OrderActions_actionBtn__3lc34"};